export const WorkGroupsMapping = {
  'Saúde': 'gt_saude',
  'Empreendedorismo': 'gt_empreendedorismo',
  'Educação': 'gt_educacao'
}
